<template>
  <div>
    <input
      :id="getFieldID(schema)"
      class="form-control checkbox error"
      type="checkbox"
      v-model="value"
      :autocomplete="schema.autocomplete"
      :disabled="disabled"
      :name="schema.inputName"
      :class="schema.fieldClasses"
      :required="schema.required"
    />
    <label :for="getFieldID(schema)"></label>
  </div>
</template>

<script>
import { abstractField } from "vue-form-generator";

export default {
  mixins: [abstractField]
};
</script>

<style lang="scss">
.vue-form-generator .field-bvm-checkbox {
  input + label {
    width: initial;
  }
}
</style>
